import setFullHeight from './helpers/setFullHeight';
import { isTouch } from './helpers/detect-device';
import { IS_PHONE, BROWSER} from './helpers/consts';

import сustomPageScroll from './components/custom-scroll';
import lineTicker from './components/line-ticker';
import initScrolllineTicker from './components/line-scroll-ticker';
import initFooter from './components/footer';
import initHeader from './components/header';
import initStoriesSlider from './components/stories-slider';
import initRecentPostsSlider from './components/recent-posts-slider';
import initInfoSection from './components/info-section';
import initVideo from './components/video';
import initProjectsSlider from './components/project-slider';
import initHeroMedia from './components/hero-media';
import initLandingMedia from './components/landing-media';
import initParallaxSections from './components/parallax-section';
import initTeamSection from './components/team-section';
import initSocialSliderSection from './components/social-slider-section';
import initHoverMedia from './components/hover-media';
import initHoverLabels from './components/hover-label';
import initAboutHero from './components/about-hero';
import initAnims from './components/anims';
import initLoader, {closeLoader} from './components/loader';
import initHome from './components/home';
import initLanding from './components/landing';
import initLandingFAQ from './components/landing-faq';
import initTextSliderSection from './components/text-slider-section';
import initTouchSection from './components/touch-section';
import filters from "./components/filters";
import initContact from "./components/contact";
import initScrollTop from "./components/scrollTop";
import initScrollLink from "./components/scrollLink";
import initScrollLinks from "./components/scrollLinks";
import initShare from "./components/share";
import initAwardsFlip from "./components/awards-flip";
import initStackableCards from "./components/stackable-content-cards";
import initOrbitCards from "./components/landing-orbit-cards";
import initBlogPost from "./components/blog-post";
import initUtmParams from "./components/utmParams";

export default () => {

	if (!isTouch()) {
		document.body.classList.add('no-touch');
	}
	else {
		document.body.classList.add('touch');
	}

	if (IS_PHONE) {
		document.body.classList.add('is-phone');
	}
	document.body.classList.add(BROWSER.name);

	setFullHeight(); //Set VH variable for mobile safari 100VH, use scss mixin fullheight()

	initLoader();

	сustomPageScroll.init(); // should be first
	initHeader();
	initAnims();

	initHome();
	initUtmParams();
	initAboutHero();
	initInfoSection();
	initHeroMedia();
	initVideo();
	initStoriesSlider();
	initRecentPostsSlider();
	initProjectsSlider();

	initLanding();
	initLandingFAQ();
	initLandingMedia();
	initStackableCards()
	initOrbitCards()
	initBlogPost();

	// about page
	initParallaxSections();
	setTimeout(() => {
		initTextSliderSection();
		initTeamSection();
		initSocialSliderSection();
	}, 1000);

	initHoverMedia();
	initHoverLabels();

	initTouchSection();
	setTimeout(() => {
		lineTicker();
		initScrolllineTicker();
	}, 2000);

	filters();
	initFooter();
	initContact();
	initScrollTop();
	initScrollLink();
	initScrollLinks();
	initShare();
	initAwardsFlip();
	closeLoader();
};
